class UserDetailsController {
    static $inject = ["$q", "$location", "stToast", "tpsrService"];

    constructor($q, $location, stToast, tpsrService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.pagestates = {
            INIT: "INIT",
            NEW_USER_EMAIL: "NEW_USER_EMAIL",
            NEW_USER_DETAILS: "NEW_USER_DETAILS",
            EDIT: "EDIT"
        }
        this.state = this.pagestates.INIT;
        this.originalUser = null;
        this.user = null;
        this.zipcodeChanging = false;
        this.cities = [];
        this.selectedCity = null;
        this.states = [];
        this.selectedState = null;
        this.noManager = { user_id: null, first_name: "No Manager", last_name: "" };
        this.managers = [];
        this.selectedManager = null;
        this.emailValid = true;
        this.emailValidReason = null;
    }

    $onInit() {

        if (this.userId) {
            this._loadUser(this.userId).then(() => {
                this._loadManagers(this.user.PIMS_customer_id).then(() => {
                    this.state = this.pagestates.EDIT;
                })
            });
        } else {
            let customer_id = this.tpsr.user.PIMS_customer_id;
            if (this.tpsr.user.is_npc_admin && this.customerId)
                customer_id = this.customerId;

            this.user = {
                user_id: null,
                PIMS_customer_id: customer_id,
                is_admin: false,
                is_manager: false,
                is_approver: false,
                manager_id: null
            };
            this._loadManagers(customer_id).then(() => {
                this.state = this.pagestates.NEW_USER_EMAIL;
            });
        }
    }

    zipCodeChanged = () => {
        this.zipcodeChanging = true;
        if (this.user.zip_code && this.user.zip_code.toString().length === 5) {
            return this._loadStatesAndCities(this.user.zip_code).finally(() => { this.zipcodeChanging = false; })
        }
        else {
            this.states.length = 0;
            this.cities.length = 0;
            this.zipcodeChanging = false;
        }
    };

    isManagerChanged = () => {
        if (this.user.is_manager)
            this.selectedManager = this.noManager;
    }

    empIdExists = value => {
        return this.tpsr.getUserforEmpId(this.user.PIMS_customer_id, value).then(result => {
            if (!result.users.length)
                return false;
            if (!this.user.user_id)
                return true;
            if (this.user.user_id === result.users[0].user_id)
                return false;
            return true;
        });
    };

    continueClicked = () => {
        return this.tpsr.getUserforEmail(this.user.email).then(result => {
            if (result.users.length) {
                this.emailValid = false;
                this.emailValidReason = "User already exists with this email";
            } else {
                this.state = this.pagestates.NEW_USER_DETAILS;
            }
        });
    };

    createUserClicked = () => {
        const request = {
            email : this.user.email,
	        first_name : this.user.first_name,
	        last_name : this.user.last_name,
	        emp_id : this.user.emp_id,
	        phone : this.user.phone,
	        PIMS_customer_id : this.user.PIMS_customer_id,
	        manager_id : this.selectedManager.user_id,

            is_npc_admin_bit: false,
            is_admin_bit: this.user.is_admin,
            is_manager_bit: this.user.is_manager,
            is_approver_bit: this.user.is_approver,

            address1 : this.user.address1,
            address2 : this.user.address2,
            city_id: this.selectedCity ? this.selectedCity.city_id : null,
            state_id: this.selectedState ? this.selectedState.state_id : null,
            zip_code : this.user.zip_code
        };
        return this.tpsr.insertUser(request).then(result => {
            this.toast.success("User Created", `User created.`)
            this.$location.url(`/customers/${this.user.PIMS_customer_id}/users`);
        });
    };

    updateUserClicked = () => {
        const request = {
            user_id: this.user.user_id,
            email: this.user.email,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            emp_id: this.user.emp_id,
            phone: this.user.phone,
            PIMS_customer_id: this.user.PIMS_customer_id,
            manager_id: this.selectedManager.user_id,

            is_npc_admin_bit: false,
            is_admin_bit: this.user.is_admin,
            is_manager_bit: this.user.is_manager,
            is_approver_bit: this.user.is_approver,

            address1: this.user.address1,
            address2: this.user.address2,
            city_id: this.selectedCity ? this.selectedCity.city_id : null,
            state_id: this.selectedState ? this.selectedState.state_id : null,
            zip_code: this.user.zip_code
        };
        return this.tpsr.updateUser(request).then(result => {
            this.toast.success("User Updated", `User updated.`)
            this.$location.url(`/customers/${this.user.PIMS_customer_id}/users`);
        });
    };

    cancelClicked = () => {
        this.$location.url(`/customers/${this.user.PIMS_customer_id}/users`);
    };



    addressOptional = () => {
        if (!this.user)
            return false;

        return this.user.is_admin || this.user.is_manager || this.user.is_approver;
    }

    _loadUser = user_id => {
        return this.tpsr.getUser(user_id).then(result => {
            //result.zip_code = parseInt(result.zip_code);
            this.user = result;
            this.originalUser = angular.copy(result);
            return this._loadStatesAndCities(this.user.zip_code).then(() => {
                this.selectedState = this.states.find(s => s.state_id === this.user.state_id);
                this.selectedCity = this.cities.find(c => c.city_id === this.user.city_id);
            });
        });
    };

    _loadManagers = PIMS_customer_id => {
        return this.tpsr.getManagers(PIMS_customer_id).then(result => { 
            this.managers.push(this.noManager);
            this.managers.push(...result.users);
            if (this.user.manager_id)
                this.selectedManager = this.managers.find(m => m.user_id === this.user.manager_id);
            else
                this.selectedManager = this.noManager;
        });
    };

    _loadStatesAndCities = zip_code => {
        this.states.length = 0;
        this.cities.length = 0;
        return this.tpsr.getStatesAndCitiesForZipcode(zip_code).then(result => {
            this.states = result.states;
            this.cities = result.cities;
            if(this.states.length)
                this.selectedState = this.states[0];
            if(this.cities.length)
                this.selectedCity = this.cities[0];
        }).then(() => {
            this.zipcodeChanging = false;
        });
    };
}

angular
    .module("app")
    .component("userDetails", { // user-details
        bindings: {
            customerId: "<",
            userId: "<"
        },
        templateUrl: "src/app/userDetails/userDetails.html",
        controller: UserDetailsController
    });
